import { rusDateTime } from '../../../utils/time';
import { downloadBlob } from '../../utils/download-files/download-blob';
import { FileType } from '../../utils/download-files/download_file';
import { selectDevice } from 'entities/device/lib';
export const download_sx_config_progress = (device_id, percent) => ({
    type: 'DOWNLOAD_SX_CONFIG_FILE__PROGRESS',
    device_id,
    percent,
});
export const download_sx_config_response = (device_id, ok, config) => (dispatch, getState) => {
    if (ok) {
        dispatch({ type: 'DOWNLOAD_SX_CONFIG_FILE__OK', device_id, config });
        const clean_date = rusDateTime(new Date())
            .replace(/:/g, '.')
            .replace(/ /g, '_');
        const device = selectDevice(getState(), device_id);
        downloadBlob(JSON.stringify(config), `config_${device?.name ?? ''}_${clean_date}.set`, FileType.other, false);
    }
    else {
        dispatch({ type: 'DOWNLOAD_SX_CONFIG_FILE__FAIL', device_id, error: true });
    }
};
export const download_sx_config_file = (device_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DOWNLOAD_SX_CONFIG_FILE', device_id });
    try {
        await api.sx_download_config(device_id);
    }
    catch ({ json }) {
        dispatch({
            type: 'DOWNLOAD_SX_CONFIG_FILE__FAIL',
            device_id,
            error: json?.error,
        });
    }
};
export const upload_sx_config_progress = (device_id, percent) => ({
    type: 'UPLOAD_SX_CONFIG_FILE__PROGRESS',
    device_id,
    percent,
});
export const upload_sx_config_response = (device_id, ok) => ok
    ? { type: 'UPLOAD_SX_CONFIG_FILE__OK', device_id }
    : { type: 'UPLOAD_SX_CONFIG_FILE__FAIL', device_id };
export const upload_sx_config_file = (device_id, config_file) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'UPLOAD_SX_CONFIG_FILE', device_id });
    try {
        await api.sx_upload_config(device_id, config_file);
    }
    catch ({ json }) {
        dispatch({
            type: 'UPLOAD_SX_CONFIG_FILE__FAIL',
            device_id,
            error: json?.error,
        });
    }
};
export const close_upload_sx_config_success = () => ({
    type: 'CLOSE_UPLOAD_SX_CONFIG_SUCCESS',
});
